import { parseUrlLoose } from 'app/utils/LooseURL';
import { getBasePath } from 'app/services/basePath';

/**
 * Tests if the given url is local or off-app-site
 * Additionally, if the url is a skype command, it is not considered off-app-site
 *
 * @param url The url to test
 * @returns isOffsite Whether or not the given url is offsite or not.
 */
export const isUrlOffAppSite = (rawUrl: string, basePath?: string) => {
  const url = parseUrlLoose(rawUrl);
  const isSkype = rawUrl.startsWith('skype:');
  const hasHostname = url.hostname !== '';
  const pathInBasePath = url.pathname.startsWith(basePath ?? getBasePath());
  return !isSkype && (hasHostname || !pathInBasePath);
};
